import { Breadcrumbs, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import * as assetApi from '../../../api/app/assetApi';
import { Asset } from '../../../types/app/asset.types';
import { paths } from '../../../utils/core/routes';
import { ApiError } from '../ApiError/ApiError';
import { Loader } from '../Loader/Loader';

interface Props {
  finalTitle: string;
  parentId: number;
}

export function AssetFullPathHeader({ finalTitle, parentId }: Props) {
  const theme = useTheme();
  const [assetFullPath, setAssetFullPath] = useState<Asset[]>([]);

  const {
    data: assetData,
    isLoading,
    isError,
  } = useQuery<Asset>(['asset', parentId], () => assetApi.getAsset(Number(parentId)));

  useEffect(() => {
    if (!assetData) return;

    const getFullPath = async (asset: Asset) => {
      let assetsFull: Asset[] = [asset];
      if (asset.parentAssetId) {
        const parent = await assetApi.getAsset(asset.parentAssetId);
        const resultParent = await getFullPath(parent);
        assetsFull = [...resultParent, ...assetsFull];
      }
      return assetsFull;
    };
    const result = getFullPath(assetData);
    result.then((x) => setAssetFullPath(x));
  }, [assetData]);

  if (isError) return <ApiError />;
  if (isLoading) return <Loader />;

  return (
    <Breadcrumbs aria-label="breadcrumb">
      {assetFullPath.map((asset: Asset) => {
        return (
          <Link
            key={asset.id}
            to={`${paths.ASSETS_DETAIL}/${asset.id}`}
            style={{
              color: theme.palette.primary.main,
              fontWeight: 600,
              textDecoration: 'underline',
            }}
          >
            <Typography component={'h4'} variant={'h4'}>
              {asset.name}
            </Typography>
          </Link>
        );
      })}
      <Typography component={'h4'} variant={'h4'} sx={{ color: theme.palette.primary.dark }}>
        {finalTitle}
      </Typography>
    </Breadcrumbs>
  );
}
